module.exports = __webpack_public_path__ + "static/media/nutritionplan.8316350e.png";